import { createSlice } from "@reduxjs/toolkit";

const wishSlice=createSlice({
name:'wish',
initialState:[],
reducers:{

    addToWish(state, action) {
        const { id } = action.payload;
        const existingItem = state.find(item => item.id === id);
        if (existingItem) {
          // If item exists, increase qty by 1
          return state.map(item => {
            if (item.id === id) {
              return { ...item, qty: item.qty + 1 };
            }
            return item;
          });
        } else {
          // If item doesn't exist, add it with qty 1
          return [...state, { ...action.payload, qty: 1 }];
        }
      },


removeFromWish(state, action) {
    const {id} = action.payload;
    return state.filter(item => item.id !== id);
  },

}



})

export const {addToWish,removeFromWish}=  wishSlice.actions;
export default wishSlice.reducer